import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './style.module.scss';

export default function FlexContainer(props) {
  const {
    alignItems = null,
    alignSelf = null,
    className = null,
    justifyContent = null,
    flexDirection = null,
    keepHeight = false,
    noShrink = false,
    growToContainer = false,
    noWrap = false,
    scroll = false,
    isHeader = false,
    ...rest
  } = props;
  return (
    <div
      {...rest}
      className={classNames(style.flexContainer, className, {
        [style[`alignItems--${props.alignItems}`]]: alignItems,
        [style[`alignSelf--${props.alignSelf}`]]: alignSelf,
        [style[`justifyContent--${justifyContent}`]]: justifyContent,
        [style[`flexDirection--${flexDirection}`]]: flexDirection,
        [style.keepHeight]: keepHeight,
        [style.noShrink]: noShrink,
        [style.growToContainer]: growToContainer,
        [style.noWrap]: noWrap,
        [style.scroll]: scroll,
        [style.header]: isHeader,
      })}
    />
  );
}

FlexContainer.propTypes = {
  className: PropTypes.string,
  alignItems: PropTypes.oneOf([
    'stretch',
    'center',
    'flexStart',
    'flexEnd',
    'baseline',
    'initial',
    'inherit',
  ]),
  alignSelf: PropTypes.oneOf([
    'stretch',
    'center',
    'flexStart',
    'flexEnd',
    'baseline',
    'initial',
    'inherit',
  ]),
  justifyContent: PropTypes.oneOf([
    'flexStart',
    'flexEnd',
    'center',
    'spaceBetween',
    'spaceAround',
    'initial',
    'inherit',
  ]),
  flexDirection: PropTypes.oneOf(['row', 'column']),
  keepHeight: PropTypes.bool,
  noShrink: PropTypes.bool,
  growToContainer: PropTypes.bool,
  noWrap: PropTypes.bool,
  scroll: PropTypes.bool,
  isHeader: PropTypes.bool,
};
